module.exports = ".row {\n    margin: 0 !important;\n    height: calc(100% - 80px);\n}\n\n.expand {\n    width: calc(100% - 80px);\n}"